<style lang="scss" >
.svg-icon {
    width: 1em;
    height: 1em;
    line-height: 1em;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    position: relative;
    fill: currentColor;
    color: inherit;
    font-size: inherit;

    >svg {
        width: 100%;
        height: 100%;
    }
}

.svg-fw {
    right: 10px;
}
</style>

<template>
    <i class="svg-icon" v-html="data">
    </i>
    <!-- <img class="svg-icon" :src="data" alt="" /> -->
</template>

<script>
export default {
    name: 'SvgIcons',
    props: {
        name: {
            type: String,
            default: 'aim',
            required: true
        }
    },
    computed: {
        iconName() {
            return `#icon-${this.name}`
        },
        data() {
            // 默认图标
            if (this.name == '') {
                return ''
            }
            try {
                let data = require(`@/assets/icons/svg/${this.name}.svg`);
                let arr = data.split('svg+xml;base64,')
                if (arr.length == 2) {
                    return this.$tool.crypto.BASE64.decrypt(arr[1]);
                }
                return this.$defaultIcon
            } catch (error) {
                console.log('错误，图标资源' + this.name + '未找到！');
                return ''
            }
        }
    },

}
</script>



// WEBPACK FOOTER //
// src/components/SvgIcon/index.vue